import React from 'react';
import { 
  Layout, 
  Lightbulb, 
  Users, 
  Upload,
  ChevronLeft, 
  ChevronRight 
} from 'lucide-react';
import { Project, TabType } from '../types';

interface SidebarProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  role?: Project['role'];
}

const adminTabs = [
  { id: 'interface' as TabType, label: 'Interface', icon: Layout },
  { id: 'tasks' as TabType, label: 'Tasks', icon: Upload },
  { id: 'enablement' as TabType, label: 'Instructions', icon: Lightbulb },
  { id: 'users' as TabType, label: 'Users', icon: Users },
];

export const Sidebar: React.FC<SidebarProps> = ({
  activeTab,
  onTabChange,
  isCollapsed,
  onToggleCollapse,
  role,
}) => {
  const isAdmin = role === 'owner' || role === 'manager';
  const tabs = isAdmin ? adminTabs : [];
  return (
    <div className={`bg-white/70 backdrop-blur border-r border-zinc-200 text-zinc-900 transition-all duration-300 flex flex-col ${
      isCollapsed ? 'w-16' : 'w-64'
    }`}>
      <div className="p-4 border-b border-zinc-200">
        <div className="flex items-center justify-between">
          {!isCollapsed && (
            <h2 className="text-lg font-semibold">Project Tools</h2>
          )}
          <button
            onClick={onToggleCollapse}
            className="p-2 hover:bg-zinc-100 rounded-lg transition-colors"
          >
            {isCollapsed ? (
              <ChevronRight className="w-5 h-5" />
            ) : (
              <ChevronLeft className="w-5 h-5" />
            )}
          </button>
        </div>
      </div>

      <nav className="flex-1 p-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`w-full flex items-center px-3 py-3 rounded-lg transition-all duration-200 mb-1 ${
                isActive
                  ? 'bg-zinc-900 text-white'
                  : 'text-zinc-700 hover:bg-zinc-100'
              }`}
              title={isCollapsed ? tab.label : undefined}
            >
              <Icon className={`w-5 h-5 ${isCollapsed ? 'mx-auto' : 'mr-3'}`} />
              {!isCollapsed && (
                <span className="font-medium">{tab.label}</span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
};